import { FirebaseError } from 'firebase-admin';
import { getAuth, multiFactor } from 'firebase/auth';
import { FC, useEffect, useState } from 'react';
import AuthContext from '@/contexts/auth';
import firebase from '@/plugins/firebaseConfig';
import { client } from '@/plugins/graphql';
import PaymentApi from '@/plugins/paymentApi';

const Settings: FC = ({ children }) => {
  const auth = getAuth(firebase);
  const currentUser = auth.currentUser;
  const [accessToken, setAccessToken] = useState<string>('');
  const enrolledFactors = auth.currentUser ? multiFactor(auth.currentUser).enrolledFactors : [];
  const [loginError, setLoginError] = useState<FirebaseError | undefined>(undefined);
  const [loginRequired, setLoginRequired] = useState<boolean>(false);

  useEffect(() => {
    // const unSubUser = onAuthStateChanged(auth, async (user) => {
    //   if (user) {
    //     setCurrentUser(user);
    //   } else {
    //     if (router.pathname != `/[schoolSlug]/login`) setCurrentUser(null);
    //     else setCurrentUser(undefined);
    //   }
    // });

    // unSubUser();

    /**
     * Refresh Token Every 20 minutes
     */
    const refreshToken = async () => {
      const _accessToken = await auth.currentUser?.getIdToken(true);
      setAccessToken(_accessToken || '');
      client.setHeaders({
        authorization: `Bearer ${_accessToken}`,
        'x-hasura-role': 'staff',
      });
      PaymentApi.getInstance().setToken(_accessToken as string);
    };
    setInterval(refreshToken, 1000 * 60 * 20);
  }, [auth]);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        loginError,
        setLoginError,
        enrolledFactors,
        auth,
        accessToken,
        setAccessToken,
        loginRequired,
        setLoginRequired,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default Settings;
